import { createFileRoute } from "@tanstack/react-router";
import { ModuleGuard } from "@/components/auth/ModuleGuard";
import Content from "@/pages/Content";

export const Route = createFileRoute("/_app/content")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ModuleGuard module="content">
      <Content />
    </ModuleGuard>
  );
}
